/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { createContext, useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import api from "@services/api"; // Import api directly here
import { URLS } from "@services/urls";
import { useTranslation } from "react-i18next";

const SessionContext = createContext({
  session: null,
  loading: false,
  token: null,
  setLoading: () => {},
  setSession: () => {},
  setToken: () => {},
  logout: () => {},
});

export function SessionProvider({ children }) {
  const { i18n } = useTranslation();

  const initialState = {
    token: localStorage.getItem("token") || null,
    session: JSON.parse(localStorage.getItem("session")) || null,
  };

  const [session, setSession] = useState(initialState.session);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(initialState.token);

  const logout = () => {
    setSession(null);
    setToken(null);
    localStorage.removeItem("session");
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("role");
    localStorage.removeItem("user_Info");
    // localStorage.removeItem("org_logo_url");
  };

  const validateAuthToken = async (tokenToCheck) => {
    try {
      const response = await api.get(URLS.auth.VALIDITY_URL, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language,
          Authorization: `Bearer ${tokenToCheck}`,
        },
      });
      return response.data;
    } catch (error) {
      logout();
      return false;
    }
  };

  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setSession(null);
        setLoading(false);
        return;
      }
      setLoading(true);
      const isValid = await validateAuthToken(token);
      if (!isValid) logout();
      setLoading(false);
    };

    checkToken();
  }, [token]);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  useEffect(() => {
    if (session) {
      localStorage.setItem("session", JSON.stringify(session));
    } else {
      localStorage.removeItem("session");
    }
  }, [session]);

  const value = useMemo(
    () => ({
      session,
      loading,
      token,
      setSession,
      setLoading,
      setToken,
      logout,
    }),
    [session, loading, token]
  );

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

SessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SessionContext;
